import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const goalsClasses = tv({
	slots: {
		wrapper: '',
		base: 'flex flex-col lg:grid lg:grid-cols-6 lg:gap-x-4 px-2 lg:px-4',
		headlineWrapper: 'w-full flex flex-col md:flex-row md:justify-between md:items-end lg:items-start lg:col-span-2 lg:flex lg:flex-col lg:h-fit lg:sticky lg:top-[12rem] xl:top-0 xl:relative xl:h-auto',
		goalsGrid: 'mt-4 lg:mt-0 lg:col-span-4 grid grid-cols-1 gap-y-1 xl:grid-cols-2 lg:gap-x-2 xl:gap-x-4 lg:gap-y-2 lg:col-start-3 lg:col-end-7',
		goalCell: `flex items-center gap-x-2 p-2 border-[1.5px] border-black rounded-[0.8rem] lg:rounded-s
     [&:nth-child(2n)>span>svg>path]:fill-white [&:nth-child(1n)>span>svg>path]:fill-black
     [&:nth-child(2n)]:border-mainPink [&:nth-child(1n)]:border-black
     [&:nth-child(2n)>strong]:text-mainPink [&:nth-child(1n)>strong]:text-black
     [&:nth-child(2n)>span]:bg-mainPink [&:nth-child(1n)>span]:bg-iconGrey

     [&:nth-child(4n-1)>span>svg>path]:xl:fill-white [&:nth-child(4n)>span>svg>path]:xl:fill-black
     [&:nth-child(4n-1)]:xl:border-mainPink [&:nth-child(4n)]:xl:border-black
     [&:nth-child(4n-1)>strong]:xl:text-mainPink [&:nth-child(4n)>strong]:xl:text-black
     [&:nth-child(4n-1)>span]:xl:bg-mainPink [&:nth-child(4n)>span]:xl:bg-iconGrey
    `,
		icon: 'h-[7.4rem] w-[7.4rem] flex justify-center items-center bg-iconGrey rounded-m shrink-0',
	},
})

export type GoalsVariants = VariantProps<typeof goalsClasses>
